/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/249-neutral2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zm2 12H6v-1h4v1zm1-8a1 1 0 110 2 1 1 0 010-2zM5 4a1 1 0 110 2 1 1 0 010-2z"/>'
  }
})
